import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Life Changes Group of Massachusetts theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const LIFECHGRP_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/lifechgrp/logo.png",
        alt: "Life Changes Group of Massachusetts Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "100px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 2,
  state: "MA",
  departmentIds: [26, 27, 28, 29, 30, 31],
};
